import { getLeagueContainer, getBettingData, getGameStates, getGridClass } from "../../../../functions/functions.js";
import PeriodTitle from "../reusablesComponent/periodTitle.js";
import FooterCard from "../reusablesComponent/footerCard.js";
import { openLink } from "../../../../functions/functions.js";
import InformationRaceComponent from "./informationRace.js";
import SecondaryTitle from "../reusablesComponent/subtitle.js";
import { useLeagueToggle } from "../../../../hooks/useLeagueToggle.js";
import BotonApostarHub from "../reusablesComponent/buttonApostar.js";
import CircuitImage from "./circuitImage.js";

/**
 * Componente especializado para mostrar tarjetas de eventos de Fórmula 1
 * Renderiza carreras con información específica del automovilismo: podios, tiempos, puntos
 * Incluye visualización de circuitos y resultados de carreras
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Array} props.leagues - Array de ligas/campeonatos de F1 con sus carreras
 * @param {boolean} props.mostrarMomios - Controla la visibilidad de momios (no usado en F1)
 * @param {boolean} props.flag_local - Bandera para configuraciones locales
 * @param {boolean} props.mostrarBotonApostar - Controla la visibilidad del botón de apuestas
 * @param {boolean} props.isStrendus - Determina qué casa de apuestas usar
 * @param {string} props.url - URL base para recursos estáticos
 * @param {boolean} props.isTenis - Indica si es tenis (siempre false para F1)
 * 
 * @returns {JSX.Element} Componente con tarjetas de carreras de Fórmula 1
 */
export default function CardFormula1({
  leagues = [],
  mostrarBotonApostar,
  isStrendus,
  isTenis = false
}) {

  // Hook para manejar el estado de expansión/colapso de ligas
  const { openMap } = useLeagueToggle(leagues);

  return (
    <>
      {leagues.map((league, leagueIdx) => {
        const { contId, id, visible, key } = getLeagueContainer(league, leagueIdx, openMap);

        return (
          <div key={key} className={`${getGridClass(league.games?.length)}`}>
            {/* Título de la liga con funcionalidad de toggle */}
            <SecondaryTitle
              leagueName={league.name}
              isVisible={visible}
              linkLiga={league.url}
              leagueImage={league.image}
            />

            {/* Contenedor de carreras de la liga */}
            <div
              id={contId}
              className="content-list-cards content-f1-tenis"
              style={{ display: "grid" }}
            >
              {Array.isArray(league.games) &&
                league.games.map((item, gameIdx) => {
                  // Funciones utilitarias para extraer lógica repetida
                  const { time_format, cls: gameClass, isNextOrError, isFinished, isError: isErrorGame } = getGameStates(item);
                  const { hasMm, apostarHref } = getBettingData(item, isStrendus);

                  // Destructuring para mejor legibilidad
                  const { utc_date, race_results, opta_event_url, period_title, game_name, venue_country, venue_name, venue_state } = item;

                  // Formateo de tiempo y determinación de estados
                  const isInProgress = gameClass === "clarosports-in-progress-game";

                  // Banderas para mostrar elementos
                  const showResults = (race_results?.podium?.length ?? 0) > 0 && (isFinished || isInProgress);
                  const shouldShowButton = mostrarBotonApostar === 'true' && !isFinished && !isErrorGame;

                  return (
                    <div key={gameIdx} className="card-complete-event card-complete-f1">
                      <div className={"card-game f1Card-maxHeight"}>

                        {/* BODY - Contenido principal de la carrera */}
                        <div className="card-body card-body-f1 f1Card-height" onClick={() => opta_event_url && openLink(opta_event_url, true)} >

                          {/* Título de la carrera */}
                          <div className="container-title-f1">
                            <h3 className="title-f1 text-break">{String(game_name).toUpperCase()}</h3>
                          </div>

                          {/* HEADER - Estado de la carrera y botón de apuestas */}
                          { gameClass === 'clarosports-next-game' &&
                            <PeriodTitle
                              clase={item.class}
                              opta_event_url={opta_event_url}
                              period_title={period_title}
                              utc_date={utc_date}
                              time_format={time_format}
                              isTenis={isTenis}
                              tenis_fase=""
                            />
                          }

                          {/* Imagen del circuito - Solo cuando NO hay resultados */}
                          {!showResults && <CircuitImage race_results={race_results} venue_name={venue_name} />}

                          {/* Componente de información de la carrera */}
                          <InformationRaceComponent item={item} showResults={showResults} />
                        </div>

                        {/* {shouldShowButton &&
                          <BotonApostarHub
                            mostrarBotonApostarCard={shouldShowButton}
                            isStrendus={isStrendus}
                            apostarHref={apostarHref}
                          />
                        } */}

                        {/* FOOTER - Información del venue */}
                        <FooterCard
                          estadio={venue_name}
                          ciudad={venue_state}
                          estado={venue_country}
                          opta_event_url={opta_event_url}
                          clase={item.class}
                          period_title={period_title}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        );
      })}
    </>
  );
}